import { ModalName } from '@/constants/modals';
import {
	mapCompanyNeedAddressToIAddress,
	missionPeriodToDateRange,
} from '@/modules/companyNeed/helpers/mission';

import type {
	CreateMissionResponse,
	MissionFormData,
	OrderAddress,
} from '@/modules/companyNeed/components/modals/createOrder/types';
import type { CompanyNeed } from '@/modules/companyNeed/types';
import type { MissionModalData } from '@/modules/companyNeed/types/missions';
import type { IAddress } from '@/types/address';

import { useModalStore } from '@/dsComponents/modals/modalStore';

type CompanyNeedWithModalId = CompanyNeed & { id?: string | null };

interface OpenManageOrderModalOptions {
	onSuccess?: (order: CreateMissionResponse) => void | Promise<void>;
	onCancel?: () => void;
}

export const openManageOrderModal = (
	need: CompanyNeedWithModalId | null | undefined,
	options?: OpenManageOrderModalOptions
) => {
	const needId = need?.id ?? need?._id;

	if (!need || !needId) {
		return;
	}
	const {
		remuneration,
		contractType,
		positionsNumber,
		address,
		companyId,
		jobId,
		startDate,
	} = need;

	const modalStore = useModalStore();
	modalStore.actions.open(ModalName.ManageOrderModal, {
		besoinId: needId,
		companyId,
		jobId,
		remuneration,
		contractType,
		positionsNumber,
		besoinAddress: address?.city
			? mapCompanyNeedAddressToIAddress(address)
			: undefined,
		besoinStartDate: startDate,
		onSuccess: options?.onSuccess,
		onCancel: options?.onCancel,
	});
};

/** Prefills the order modal form from mission details, to edit or duplicate the mission. */
export const toManageOrderMissionForm = (
	mission: MissionModalData,
	getFallbackAddress?: () => OrderAddress
): MissionFormData => ({
	name: mission.name,
	hiringReason: mission.hiringReason,
	justification: mission.explanation,
	description: mission.description,
	note: mission.note,
	remuneration: mission.remuneration,
	showRemuneration: mission.showRemuneration,
	contractType: mission.contractType,
	totalPositions: mission.totalPositions,
	address: (mission.address ?? getFallbackAddress?.()) as unknown as IAddress,
	periods: mission.periods.map(missionPeriodToDateRange),
});
